import {AxiosInstance} from "axios";
import BugFolderRepositoryInterface from "@/services/Bug-report/Bug-report/Folders/interfaces";
import {BugReportFolderEntity} from "@fenix/bug-report-entities/bug-report-entities";

export default class BugFolderRepository implements BugFolderRepositoryInterface {
  constructor(private readonly axios: AxiosInstance) {
  }

  async create(DTOs: { folderId: number, private: boolean }[]): Promise<BugReportFolderEntity[]> {
    const url = '/bug-report/bugs/folder'
    const res = await this.axios.post(url, DTOs);

    return res.data;
  }

  async getAll(page?: number, take?: number): Promise<BugReportFolderEntity[]> {
    const url = `/bug-report/bugs/folder?page=${page ?? ''}&take=${take ?? ''}`;
    const res = await this.axios.get(url);

    return res.data;
  }
}
